import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import around from "../assets/images/giro_horizontal.png";
import { APP_URL } from "../util/constants/APP_URL";
import { isMobile } from "../util/methods/responsive";


const Layout = ({ children }: { children: any }) => {
  const location = useLocation();

  const [audio] = useState(new Audio("/sounds/musica.mp3"));
  const [isAudioAllowed, setIsAudioAllowed] = useState(false);
  const [isPortrait, setIsPortrait] = useState<boolean>(window.innerHeight > window.innerWidth);

  const noAllowPath = [
    "/home",
    "/cursos",
    "/dashboard"
  ];

  const minusVolume = APP_URL.QUIZ.MESSAGE

  useEffect(() => {
    const handleFirstClick = () => {
      setIsAudioAllowed(true);
      window.removeEventListener("click", handleFirstClick);
    };

    const handleResize = () => {
      setIsPortrait(window.innerHeight > window.innerWidth);
    }

    document.addEventListener("touchstart", requestFullScreen);
    window.addEventListener("resize", handleResize);
    window.addEventListener("click", handleFirstClick);

    return () => {
      window.removeEventListener("click", handleFirstClick);
      document.removeEventListener("touchstart", requestFullScreen);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (isAudioAllowed) {
      if (!isInclude()) {
        audio.loop = true;
        audio.volume = shouldReduceVolume() ? 0.04 : 0.09;
        audio.play().catch((error) => {
          console.error("Error al intentar reproducir el audio:", error);
        });
      } else {
        audio.pause();
        audio.currentTime = 0;
      }
    }
  }, [location, isAudioAllowed, audio]);

  const isInclude = () => {
    const pathname = location.pathname;
    let pathInclude = false;

    for (const path of noAllowPath) {
      pathInclude = pathname.includes(path);
      if (pathInclude) break;
    }

    return pathInclude
  }

  const shouldReduceVolume = () => {
    const pathname = location.pathname;
    return pathname.includes(minusVolume);
  }

  const requestFullScreen = () => {
    const element = document.documentElement;
    if (element.requestFullscreen) {
      element.requestFullscreen();
    } else if ((element as any).webkitRequestFullscreen) {
      (element as any).webkitRequestFullscreen();
    } else if ((element as any).msRequestFullscreen) {
      (element as any).msRequestFullscreen();
    }
  };

  return (
    <main className="main">
      {children}
      {
        isPortrait && isMobile() &&
        <div className="around_section">
          <div>
            <label className="ft-EricssonGA628 title">Gire su pantalla</label>
            <img src={around} width={120} height={120} />
            <label className="ft-EricssonGA628 subtitle">Para una mejor experiencia</label>
          </div>
        </div>
      }
      <div className="dashboard-footer pie-title ft-EricssonGA628 fixed">
        Diseñado y producido por Plopstudio.com
      </div>
    </main>
  );
};

export default Layout;
